import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { ArrowCounterClockwise, ClockCounterClockwise } from "@phosphor-icons/react";
import { api } from "../../lib/api";

const TYPE_LABEL = { publish: "Published", approve: "Approved change", rollback: "Rollback" };

export const HistoryPanel = ({ onChange }) => {
  const [versions, setVersions] = useState([]);
  const load = () => api.get("/admin/versions").then((r) => setVersions(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const rollback = async (v) => {
    if (!window.confirm(`Roll the whole site back to version ${v.version_no}? A new version will be recorded.`)) return;
    try {
      await api.post(`/admin/versions/${v.id}/rollback`);
      toast.success(`Rolled back to version ${v.version_no}`);
      load(); onChange && onChange();
    } catch (e) { toast.error(e?.response?.data?.detail || "Rollback failed"); }
  };

  return (
    <div data-testid="history-panel">
      <p className="text-navy/60 text-sm mb-6 flex items-center gap-2"><ClockCounterClockwise size={18} /> Every published change is saved as a version. Master accounts can restore any earlier version.</p>
      <div className="space-y-3">
        {versions.length === 0 && <p className="text-navy/50">No versions yet.</p>}
        {versions.map((v, i) => (
          <div key={v.id} className="bg-white border border-navy/10 p-4 flex flex-wrap items-center justify-between gap-3" data-testid={`version-${v.version_no}`}>
            <div className="flex items-center gap-4">
              <span className="font-heading text-2xl text-gold w-14">v{v.version_no}</span>
              <div>
                <div className="font-medium text-navy">{v.description || TYPE_LABEL[v.change_type] || v.change_type}
                  {i === 0 && <span className="ml-2 text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded-sm">Current</span>}
                </div>
                <div className="text-xs text-navy/50">{v.changed_by_email} · {new Date(v.created_at).toLocaleString()}</div>
              </div>
            </div>
            {i !== 0 && (
              <button onClick={() => rollback(v)} data-testid={`rollback-${v.version_no}`} className="inline-flex items-center gap-2 border border-navy/20 text-navy font-semibold px-4 py-2 rounded-sm hover:border-gold transition-colors text-sm">
                <ArrowCounterClockwise size={16} /> Restore
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
